/** @format */

import React from 'react'

import './style.css'

export default function SearchNavbar() {
	return <div className='ph-navbar-tools-container-spacer'></div>
}
